<script setup lang="ts">
  import { useFetchDataFromStoryblok } from '@/composables/fetchDataFromStoryblok'
  import { getLogoData, getProfileData, getNavigationData } from '@/utils/sbDataParsers'
  import { useMainHeaderStore } from '@/components/main-header/store'

  const { isDesktop } = useBTBreakpoints()

  const resolveRelations = [
    'top-navigation-item.link',
    'top-navigation.buttons',
    'top-navigation.profile',
    'header-link.link',
    'header-search.searchLink',
    'header-profile.newProfileLinks',
    'header-profile.oldProfileLinks'
  ]
  const slug = 'main-navigation/navigation'

  const topBarStory = await useFetchDataFromStoryblok(slug, resolveRelations)
  const topBarContent = topBarStory.value?.content
  const profileContent = topBarContent?.profile?.content

  const mainHeaderStore = useMainHeaderStore()
  mainHeaderStore.logo = getLogoData(topBarContent)

  const navigation = computed(() => getNavigationData(topBarContent?.buttons))
  const profile = computed(() => getProfileData(profileContent))

  const showComponent = (component: string) => {
    if (component === 'header-search') {
      return isDesktop.value
    }

    return true
  }
</script>

<template>
  <div class="container flex items-center justify-between border-b border-divider p-0">
    <div class="ml-2 flex items-center gap-2 md:m-0">
      <button
        v-if="!isDesktop"
        class="flex size-10 items-center justify-center"
        :aria-label="$t('aria.label.hamburgerMenu')"
        type="button"
        @click="mainHeaderStore.isMenuOpen = true"
      >
        <Icon name="common/menu-burger" />
      </button>
      <MainHeaderLogo
        v-if="mainHeaderStore?.logo"
        :logo="mainHeaderStore.logo"
      />
    </div>
    <div class="flex items-center justify-end sm:mr-2 sm:gap-4 md:m-0 md:gap-5">
      <div class="flex items-center gap-1 sm:gap-4">
        <template
          v-for="(item, itemIndex) in navigation"
          :key="`${item.component}_${itemIndex}`"
        >
          <component
            :is="item.component"
            v-if="showComponent(item.component)"
            :item="item"
          />
        </template>
      </div>

      <HeaderProfile
        v-if="profile"
        :profile="profile"
      />
    </div>
  </div>
</template>
